import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { AddUserDialogWrapper } from "./AddUserDialogStyled";
import { Controller, useForm } from "react-hook-form";
import { Constants } from "../Content";
import {
  addNewUserDetails,
  getAllUsersAllRoles,
  getCurrentUserInfofromAD,
} from "../../../Actions/UserAction";
import { useDispatch } from "react-redux";
import Notification from "../../utilities/Notification/Notification";
import { Severity } from "../../utilities/Notification/NotificationContent";
import { Congiguration } from "../../../Constants/AppConstants";
import ConfirmationBox from "../../ManageData/Popups/ConfirmationBox";
import Loader from "../../utilities/Loader/Loader";

const AddUserDialog = ({
  show,
  title,
  type,
  handleConfirmClick,
  handleCancelClick,
  isEdit,
  editData,
}) => {
  const inputRef = useRef(null);
  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  });
  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    setError,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const dispatch = useDispatch();
  const [showNotification, setShowNotification] = useState(false);
  const [showalretdialog, setShowalretdialog] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationSeverity, setNotificationSeverity] = useState("");
  const [allUsersList, setAllUsersList] = useState();
  const [allRolesList, setAllRolesList] = useState();
  const [userId, setUserId] = useState(null);
  const [form, setForm] = useState();
  const [loadingState, setLoadingState] = useState(false);
  const [saveButtonDisable, setSaveButtonDisable] = useState(false);
  const [userEmailCheck, setuserEmailCheck] = useState('')

  React.useEffect(() => {
    setUserId(isEdit ? editData?.userId : null);
    setValue("email", isEdit ? editData?.email : "");
    setValue("roleId", isEdit ? editData?.roleId : "");
    // setValue("isActive", isEdit ? editData?.isActive === "Active" : "");
    setValue("isActive", isEdit ? editData?.isActive : "Active");
    setValue("firstName", isEdit ? editData?.firstName : null);
    setValue("lastName", isEdit ? editData?.lastName : null);
  }, [
    editData?.email,
    editData?.firstName,
    editData?.lastName,
    editData?.roleId,
    editData?.isActive,
    isEdit,
    setValue,
  ]);

  const closeNotificationPopup = () => {
    setShowNotification(false);
  };

  useEffect(() => {
    getUsersandRoles();
  }, []);
  const handleFetchInfo = () => {
    setLoadingState(true)
    console.log("loading...");
    const userEmail = allUsersList?.map((user) => user?.email);
  
    setuserEmailCheck(getValues("email"))
    
    getCurrentUserInfofromAD(getValues("email"))
      .then((res) => {
        setLoadingState(false)
        if (res?.data?.firstName === null && res?.data?.lastName === null) {
          setError(
            "email",
            { type: "custom", message: Constants.EMAILVALIDATION },
            { shouldFocus: true }
          );
        }
        setValue("firstName", res?.data?.firstName);
        setValue("lastName", res?.data?.lastName);
      })
      .catch((err) => {
        setLoadingState(false)
        setError(
          "email",
          { type: "custom", message: Constants.EMAILVALIDATION },
          { shouldFocus: true }
        );
      });
  };

  const getUsersandRoles = () => {
    dispatch(getAllUsersAllRoles()).then((data) => {
      data.usersAndRoles.forEach((el) => {
        el.isActive = el.isActive ? "Active" : "Inactive";
      });
      data.rolesAndActions.forEach((el) => {
        el.isActive = el.isActive ? "Active" : "Inactive";
      });
      setAllUsersList(data.usersAndRoles);
      setAllRolesList(removeDuplicatesByRoleName(data.rolesAndActions));
    });
  };

  const handleAlertConfirm = (data = null) => {
    setShowalretdialog(false);
    addNewUserDetails(data ? data : form)
      .then((res) => {
        handleConfirmClick();
      })
      .catch((err) => {
        console.log(err);
        setNotificationMessage(Constants.GENERALMESSAGE);
        setNotificationSeverity(Severity.ERROR);
        setShowNotification(true);
        setSaveButtonDisable(false);
      });
  };
  const handleAlertCancel = () => {
    setSaveButtonDisable(false);

    setShowalretdialog(false);
  };
    const emailPattern = /^[a-zA-Z0-9._%+-]+@workplaceoptions\.com$/;
    
  const onSubmit = (data) => {
    if (saveButtonDisable) return;
    const userEmail = allUsersList?.map((user) => user?.email);
    const containsStringCaseIgnoreRegex = new RegExp(userEmail?.join("|"), "i");

    if (!emailPattern.test(getValues("email"))) {
      setError(
        "email",
        { type: "custom", message: Constants.EMAILVALIDATION },
        { shouldFocus: true },
        { required: Constants.EMAILREQUIRED }
      );
      return;
    }
    if(userEmailCheck!==''&&(getValues("email").toLowerCase()!==userEmailCheck.toLowerCase())){
      setError(
        "email",
        { type: "custom", message: Constants.USEREMAILCHANGED },
        { shouldFocus: true }
      );
      return;
    }
    if (!getValues("roleId")) {
      setError(
        "roleId",
        { type: "custom", message: Constants.ROLEISREQUIRED },
        { shouldFocus: true }
      );
      return;
    }
    if (isEdit) {
      if (editData?.email !== data?.email && userEmail.includes(data?.email)) {
        setError(
          "email",
          { type: "custom", message: Constants.USEREXISTS },
          { shouldFocus: true }
        );
        return;
      }
    } else if (containsStringCaseIgnoreRegex.test(data?.email)) {
      setError(
        "email",
        { type: "custom", message: Constants.USEREXISTS },
        { shouldFocus: true }
      );
      return;
    }

    if (!data?.firstName && !data?.lastName) {
      setNotificationMessage(Constants.FETCHVALIDATION);
      setNotificationSeverity(Severity.WARNING);
      setShowNotification(true);
      return;
    }

    setForm({
      ...data,
      isActive: data?.isActive === "Active",
      userId: userId,
      companyId: Congiguration.CompanyId,
    });
    setSaveButtonDisable(true);

    if (isEdit) {
      setShowalretdialog(true);
      return;
    } else {
      handleAlertConfirm({
        ...data,
        isActive: data?.isActive === "Active",
        userId: userId,
        companyId: Congiguration.CompanyId,
      });
    }
  };
  function removeDuplicatesByRoleName(array) {
    const uniqueRoles = new Set();
    return array.filter((item) => {
      if (item.isActive === "Active" && !uniqueRoles.has(item.roleName)) {
        uniqueRoles.add(item?.roleName);
        console.log(uniqueRoles, "uniquee");
        return true;
      }
      return false;
    });
  }

  return (
    <div>
      <AddUserDialogWrapper
        open={show}
        onClose={handleCancelClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="paper"
        maxWidth="md"
        fullWidth={true}
        height="100vh"
      >
        <DialogTitle id="alert-dialog-title" className="customDialogTitle">
          {isEdit ? Constants.EDITUSER : title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className="customDialog"
          >
            <div>
              <div className="inputform">
                <div className="field">
                  <label>
                    <strong>{Constants.EMAIL}</strong>{" "}
                    <span className="red"> *</span>
                  </label>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        onBlur={(e) => {
                          if (isEdit && e?.target?.value !== editData?.email) {
                            setValue("firstName", "");
                            setValue("lastName", "");
                          }
                        }}
                        className="formValue"
                        placeholder="Type here"
                        size="small"
                        defaultValue={isEdit ? editData?.ddd : ""}
                        error={!!errors.email}
                        helperText={errors.email && errors.email.message}
                      />
                    )}
                  />
                </div>
                <div className="fetchfield">
                  <Button
                    style={{ fontWeight: "bold" }}
                    variant="outlined"
                    className="fetchButton"
                    onClick={handleFetchInfo}
                  >
                    {Constants.FETCH}
                  </Button>
                </div>
              </div>
              <div className="inputform">
                <div className="field">
                  <label>
                    <strong>{Constants.FIRSTNAME}</strong>
                  </label>

                  <Controller
                    name="firstName"
                    control={control}
                    defaultValue={""}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        disabled={true}
                        className="formValue textfieldbg"
                        placeholder="Fetch to populate"
                        size="small"
                      />
                    )}
                  />
                </div>
                <div className="field">
                  <label>
                    <strong>{Constants.LASTNAME}</strong>
                  </label>
                  <Controller
                    name="lastName"
                    control={control}
                    defaultValue={""}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        disabled={true}
                        className="formValue textfieldbg"
                        placeholder="Fetch to populate"
                        size="small"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="inputform">
                <div className="field">
                  <label>
                    <strong>{Constants.ROLE}</strong>
                    <span className="red"> *</span>
                  </label>
                  <FormControl className="customDropdown">
                    <Controller
                      name="roleId"
                      control={control}
                      defaultValue=""
                      rules={{ required: Constants.ROLEISREQUIRED }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          variant="outlined"
                          fullWidth
                          margin="normal"
                          error={!!errors.role}
                          displayEmpty
                          size="small"
                          helperText={errors.role && errors.role.message}
                        >
                          <MenuItem divider dense disabled value="">
                            Select Role
                          </MenuItem>
                          {allRolesList?.map((role) => (
                            <MenuItem
                              divider
                              dense
                              key={role.roleId}
                              value={role.roleId}
                            >
                              {role.roleName}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                  {errors.roleId && (
                    <p className="error">{errors?.roleId?.message}</p>
                  )}
                </div>
                <div className="field">
                  <label>
                    <strong>{Constants.STATUS}</strong>
                    <span className="red"> *</span>
                  </label>
                  {isEdit ? (
                    <FormControl className="customDropdown">
                      <Controller
                        name="isActive"
                        control={control}
                        defaultValue=""
                        rules={{ required: Constants.STATUSISREQUIRED }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            error={!!errors.isActive}
                            displayEmpty
                            size="small"
                            helperText={
                              errors.isActive && errors.isActive.message
                            }
                          >
                            <MenuItem value={"Active"}>Active</MenuItem>
                            {isEdit && (
                              <MenuItem value={"Inactive"}>Inactive</MenuItem>
                            )}
                          </Select>
                        )}
                      />
                    </FormControl>
                  ) : (
                    <Controller
                      name="isActive"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          disabled={true}
                          className="formValue textfieldbg"
                          size="small"
                        />
                      )}
                    />
                  )}
                  {errors.isActive && (
                    <p className="error">{errors?.isActive?.message}</p>
                  )}
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>

        <DialogActions className="dialogbutton">
          <>
            <Button
              variant="outlined"
              className="rightButton"
              onClick={handleCancelClick}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="confirmButton"
              color="success"
              type="submit"
              disabled={saveButtonDisable}
              onClick={handleSubmit(onSubmit)}
            >
              Save
            </Button>
          </>
        </DialogActions>
        {showNotification && (
          <Notification
            open={showNotification}
            onClose={closeNotificationPopup}
            message={notificationMessage}
            severity={notificationSeverity}
          />
        )}
        {showalretdialog && (
          <ConfirmationBox
            show={showalretdialog}
            handleCancelClick={handleAlertCancel}
            handleConfirmClick={() => {
              handleAlertConfirm(form);
            }}
            title={Constants.CONFIRM}
            message={Constants.SAVEUSER}
          />
        )}
         {loadingState && <Loader open={loadingState} />}
      </AddUserDialogWrapper>
    </div>
  );
};

export default AddUserDialog;
